import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLoaderData } from "react-router-dom";
import "./Dashboard.css";
import { Typography } from "@mui/material";
import { CardSkeleton, DashCard } from "../../../../../components";
import {
  getAllOwnRequestsToOthersBerths,
  getAllRequestsToOwnBerths,
} from "../../../../../services";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export const Dashboard = () => {
  const user = useLoaderData();
  const [othersRequests, setOthersRequests] = useState(null);
  const [ownRequests, setOwnRequests] = useState(null);

  const getOthersRequests = async () => {
    const res = await getAllRequestsToOwnBerths(user?.token);

    if (res?.status === true) {
      setOthersRequests(res?.data?.sort((a, b) => a?.id - b?.id));
      return;
    }

    if (res?.status === false) {
      if (res?.message === "Invalid or expired access token.") {
        toast.error("Token expired, please re-login and try");
        setOthersRequests(null);
        return;
      }

      if (res?.message === "no swap or rent transactions found") {
        setOthersRequests([]);
        return;
      }

      toast.error("Something went wrong please try later");
      setOthersRequests(null);
      return;
    }

    toast.error("Something went wrong please try later");
    setOthersRequests(null);
    return;
  };

  const getOwnRequests = async () => {
    const res = await getAllOwnRequestsToOthersBerths(user?.token);

    if (res?.status === true) {
      setOwnRequests(res?.data?.sort((a, b) => a?.id - b?.id));
      return;
    }

    if (res?.status === false) {
      if (res?.message === "Invalid or expired access token.") {
        toast.error("Token expired, please re-login and try");
        setOwnRequests(null);
        return;
      }

      if (res?.message === "no swap or rent transactions found") {
        setOwnRequests([]);
        return;
      }

      toast.error("Something went wrong please try later");
      setOwnRequests(null);
      return;
    }

    toast.error("Something went wrong please try later");
    setOwnRequests(null);
    return;
  };

  useEffect(() => {
    getOthersRequests();
    getOwnRequests();
  }, []);

  return (
    <>
      <Box style={{ marginBottom: '30px' }}>
        <Typography variant="h3" className="page-title">
          Current requests to your berths
        </Typography>
        <Grid container spacing={3}>
          {othersRequests === null ? (
            <CardSkeleton />
          ) : othersRequests?.length === 0 ? (
            <Grid item xs={12}>
              <Card sx={{ width: '100%', height: '150px' }}>
                <CardContent sx={{ height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <h3 style={{ textAlign: 'center' }}>Berth requests not found!</h3>
                </CardContent>
              </Card>
            </Grid>
          ) : (
            othersRequests?.map((data) => (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <DashCard type="request" value={data} />
              </Grid>
            ))
          )}
        </Grid>
      </Box>
      
      <Box style={{ marginBottom: '30px' }}>
        <Typography variant="h3" className="page-title">
          Your requests to others berths
        </Typography>
        <Grid container spacing={3}>
          {ownRequests === null ? (
            <CardSkeleton />
          ) : ownRequests?.length === 0 ? (
            <Grid item xs={12}>
              <Card sx={{ width: '100%', height: '150px' }}>
                <CardContent sx={{ height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <h3 style={{ textAlign: 'center' }}>Berth requests not found!</h3>
                </CardContent>
              </Card>
            </Grid>
          ) : (
            ownRequests?.map((data) => (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <DashCard type="own_request" value={data} />
              </Grid>
            ))
          )}
        </Grid>
      </Box>
    </>
  );
};
